import React from 'react'
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { useDrag } from 'react-dnd'
import classNames from 'classnames';

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const styles = theme => ({
    box:{
        cursor: 'move',
    },
    useBox:{
        backgroundImage: 'repeating-linear-gradient(-45deg, transparent, transparent 4px, rgba(64,186,208,0.2) 4px, rgba(64,186,208,0.2) 6px )',
        backgroundColor: 'rgba(255, 255, 255, 1) !important',
        backgroundSize:'auto auto',
    }
});

const DragTarget = ({ classes, data, func, isUse }) => {
    const [{ isDragging }, drag] = useDrag({
        item: { data, type: 'box' },
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult();
            if (item && dropResult) {
                func(item.data, dropResult.value);
            }
        },
        collect: monitor => ({
            isDragging: monitor.isDragging(),
        }),
    });
    let backgroundColor = isDragging ? "rgb(244,244,244)":"rgb(255,255,255)";

    return (
        <div ref={drag} className={classNames(classes.box,isUse ? classes.useBox : '')} style={{backgroundColor}} >
            <ListItem ContainerComponent="div" dense>
                <ListItemText primary={data} />
            </ListItem>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        navigation : state.navigation
    };
}
export default compose(
    withStyles(styles),
    connect(mapStateToProps)
)(DragTarget);



// WEBPACK FOOTER //
// ./src/routes/mapping/step2/components/drag-target.js